<script>
// import MultiSelect from "vue-multiselect";
import Drawer from "@/components/drawer.vue";

// Custom Components
import PageHeader from "@/components/page-header";
import PbxService from "@/helpers/APIService/pbx.service";
import InvoicelyService from "@/helpers/APIService/invoicely.service.js";
import CustomerDetails from "@/components/superAdmin/customer/index.vue";
import HandleLogic from "@/helpers/handleLogic";
import Middleware from "@/helpers/middlewares";
import errorHandler from "@/helpers/errorHandler";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Customer list",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    PageHeader,
    // MultiSelect,
    CustomerDetails,
    Drawer,
  },
  data() {
    return {
      title: "PBX Customer List",
      table: {
        tableData: [],
        totalPages: 1,
        pageNumber: 1,
        size: 50,
      },
      selectedDomain: null,
      isLoading: false,
      hotels: [],
      filters: {
        pbx: "",
        domain: "",
      },
      pbxOptions: [],
      domainOptions: [],
      isFilterLoading: false,
      selectedCustomer: null,
      isShowCustomerForm: false,
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.getDomain(`?and_custom_fields__has_key=domain_name`);
  },
  methods: {
    // Method is used to get doamin list
    async getDomain(filter) {
      this.isLoading = true;
      try {
        const response = await InvoicelyService.getCustomerListPBX(filter);
        if (response) {
          this.isFilterLoading = false;
          this.isLoading = false;
          if (response.status == false) {
            return Middleware.notification(response.message, "warning");
          }
          if (response.results.length == 0) {
            this.table.tableData = [];
            return;
          }
          localStorage.setItem(
            "domain_options",
            JSON.stringify(response.results)
          );
          this.table.tableData = [];
          this.table.totalPages = response.total_pages;
          this.table.pageNumber = response.page_number;
          response.results.map((item) => {
            if (!String(item.domain_name).match(/\d/g)) {
              if (item.hotel_data !== null) {
                this.table.tableData.push({
                  ...item,
                  domain_enabled: item.domain_enabled == "true" ? true : false,
                  domain_subscription:
                    item.domain_subscription == "true" ? true : false,
                });
              }
            }
          });
          if (this.domainOptions.length !== 0) return;
          const domainOpArray = [];
          const pbxOpArray = [];
          this.table.tableData.map((item) => {
            pbxOpArray.push({ text: item.pbx, value: item.pbx });
            domainOpArray.push({
              text: item.domain_name,
              value: item.domain_uuid,
            });
          });
          this.domainOptions = HandleLogic.uniqueArrayHandle(
            domainOpArray,
            "value"
          );
          this.pbxOptions = HandleLogic.uniqueArrayHandle(pbxOpArray, "value");
        }
      } catch (error) {
        this.isFilterLoading = false;
        this.isLoading = false;
        errorHandler(error);
      }
    },

    // Method is used to update domain details
    viewCustomerDetail(customer) {
      this.$router.push(`/customer-detail?domain_uuid=${customer.domain_uuid}`);
    },

    // Method is used to handle domain status change
    changeStatus(customer, data) {
      PbxService.updateDomainStatus(customer.domain_uuid, data)
        .then((response) => {
          if (response.status == false) {
            return Middleware.notification(response.message, "warning");
          }
          Middleware.notification("Status change successfully !!", "success");
        })
        .catch((error) => {
          errorHandler(error);
        });
    },

    // Method is used to copy code
    copyCode(data) {
      Middleware.copyCode(data);
    },

    // Method is used to open portal
    openDomain(domain) {
      if (domain.domain_uuid !== null) {
        HandleLogic.openPbxDomain({ domain_uuid: domain.domain_uuid });
      }
    },
    // Method is used to handle hotel form
    hotelForm() {
      this.isEdit = false;
      this.selectedCustomer = null;
      this.isShowCustomerForm = !this.isShowCustomerForm;
    },
    // Method is used to handle hotel submission
    handleHotelSubmit(data) {
      this.getDomain(`?and_custom_fields__has_key=domain_name`);
      this.hotelForm();
    },

    updateCustomerDetail(customer) {
      this.selectedCustomer = customer;
      this.isEdit = true;
      this.isShowCustomerForm = !this.isShowCustomerForm;
    },
    // Method is used to handle appy filter
    filterApply(filter_process) {
      this.isFilterLoading = true;
      let query = "?and_custom_fields__has_key=domain_name";
      let checkIsFirst = true;
      if (filter_process == "clear") {
        this.filters = {
          pbx: "",
          domain: "",
        };
        this.getDomain(
          `?and_custom_fields__has_key=domain_name&page_size=${this.table.size}`
        );
      } else {
        Object.keys(this.filters).map((item) => {
          let key = item;
          if (this.filters[item] !== "") {
            if (item == "domain") {
              this.filters[item] = this.filters[item].value;
              key = "domain_uuid";
            }
            if (item == "pbx") {
              this.filters[item] = this.filters[item].value;
            }
            if (!checkIsFirst) {
              checkIsFirst = true;
              query += `?${key}=${this.filters[item]}`;
            } else {
              query += `&${key}=${this.filters[item]}`;
            }
          }
        });
        if (checkIsFirst && query !== "") {
          this.getDomain(query);
          this.filters = {
            pbx: "",
            domain: "",
          };
        } else {
          this.isFilterLoading = false;
        }
      }
    },
  },
};
</script>
<template>
  <div>
    <PageHeader :title="title" />
    <!-- :action="hotelForm"
      text="Add New Customer"
      :isButton="true" -->
    <b-card>
      <!-- <div class="row align-items-center">
        <div
          class="col-xxl-2 col-lg-3 col-md-4 col-sm-6"
          v-for="(filterItem, index) in filters"
          :key="index"
        >
          <input
            type="text"
            class="form-control mb-2"
            :placeholder="` ${index.replaceAll('_', ' ')}`"
            v-model="filters[index]"
            v-if="index !== 'domain' && index !== 'pbx'"
          />
          <MultiSelect
            v-if="index == 'domain'"
            class="mb-2"
            v-model="filters.domain"
            :options="domainOptions"
            :show-labels="false"
            placeholder="Search with domain"
            track-by="value"
            label="text"
            name="domains"
          />
          <MultiSelect
            v-if="index == 'pbx'"
            class="mb-2"
            v-model="filters.pbx"
            :options="pbxOptions"
            :show-labels="false"
            placeholder="Search with pbx"
            track-by="value"
            label="text"
            name="pbx_list"
          />
        </div>

        <div class="col-xxl-2 col-lg-3 col-md-4 col-sm-12">
          <div class="float-end float-lg-start">
            <button
              class="btn btn-primary mb-2 me-2"
              @click="filterApply('apply')"
              :disabled="isFilterLoading"
            >
              Apply Filter
            </button>
            <button
              class="btn btn-primary mb-2"
              @click="filterApply('clear')"
              :disabled="isFilterLoading"
            >
              Clear Filter
            </button>
          </div>
        </div>
      </div> -->
      <div class="table-responsive">
        <v-table
          class="table table-hover mb-0"
          ref="my-table"
          infinite-scroll-disabled="busy"
          infinite-scroll-distance="10"
          :data="table.tableData"
        >
          <thead class="table-light" slot="head">
            <tr>
              <v-th sortKey="domain_name">Domain name</v-th>
              <v-th sortKey="pbx">PBX</v-th>
              <v-th sortKey="hotel_data.name">Company</v-th>
              <th>Porting</th>
              <th>Subscription</th>
              <v-th sortKey="hotel_data.manager_name">Contact Person</v-th>
              <v-th sortKey="hotel_data.manager_number">Mobile</v-th>
              <v-th sortKey="hotel_data.front_desk_number">
                Frontdesk Number
              </v-th>
              <v-th sortKey="hotel_data.city">City</v-th>
              <v-th sortKey="hotel_data.state">State</v-th>
              <!-- <th>Action</th> -->
            </tr>
          </thead>
          <tbody
            class="infinite-list"
            slot="body"
            slot-scope="{ displayData }"
            v-if="!isLoading && table.tableData.length > 0"
          >
            <tr v-for="customer in displayData" :key="customer.id">
              <td>
                <span @click="openDomain(customer)" class="text-primary cursor">
                  {{ customer.domain_name ? customer.domain_name : "-" }}</span
                >
                <i
                  class="far fa-copy text-primary ms-1"
                  @click="copyCode(customer.domain_name)"
                ></i>
              </td>
              <td @click="viewCustomerDetail(customer)">
                {{ customer.pbx ? customer.pbx : "--" }}
              </td>
              <td @click="viewCustomerDetail(customer)">
                {{
                  customer.hotel_data
                    ? customer.hotel_data.name
                      ? customer.hotel_data.name
                      : "--"
                    : "--"
                }}
              </td>
              <td>
                <div class="form-check form-switch my-1" slot="porting">
                  <input
                    class="form-check-input"
                    id="porting"
                    type="checkbox"
                    v-model="customer.domain_enabled"
                    @click="
                      changeStatus(customer, {
                        domain_enabled: String(!customer.domain_enabled),
                      })
                    "
                  />
                </div>
              </td>
              <td>
                <div class="form-check form-switch my-1" slot="subscription">
                  <input
                    class="form-check-input"
                    id="subscription"
                    type="checkbox"
                    v-model="customer.domain_subscription"
                    @click="
                      changeStatus(customer, {
                        domain_subscription: String(
                          !customer.domain_subscription
                        ),
                      })
                    "
                  />
                </div>
              </td>
              <td @click="viewCustomerDetail(customer)">
                {{
                  customer.hotel_data
                    ? customer.hotel_data.manager_name
                      ? customer.hotel_data.manager_name
                      : "--"
                    : "--"
                }}
              </td>
              <td @click="viewCustomerDetail(customer)">
                {{
                  customer.hotel_data
                    ? customer.hotel_data.manager_number
                      ? customer.hotel_data.manager_number
                      : "--"
                    : "--"
                }}
              </td>
              <td @click="viewCustomerDetail(customer)">
                {{
                  customer.hotel_data
                    ? customer.hotel_data.front_desk_number
                      ? customer.hotel_data.front_desk_number
                      : "--"
                    : "--"
                }}
              </td>
              <td @click="viewCustomerDetail(customer)">
                {{
                  customer.hotel_data
                    ? customer.hotel_data.city
                      ? customer.hotel_data.city
                      : "--"
                    : "--"
                }}
              </td>
              <td @click="viewCustomerDetail(customer)">
                {{
                  customer.hotel_data
                    ? customer.hotel_data.state
                      ? customer.hotel_data.state
                      : "--"
                    : "--"
                }}
              </td>
              <!-- <td>
                <div class="d-flex align-items-center">
                  <i
                    v-b-popover.hover="'Edit'"
                    class="fas fa-pencil-alt text-success me-2"
                    @click="updateCustomerDetail(customer)"
                  ></i>
                  <i
                    v-b-popover.hover="'View'"
                    class="fas fa-eye text-success"
                    @click="viewCustomerDetail(customer)"
                  ></i>
                </div>
              </td> -->
            </tr>
          </tbody>
          <tbody v-else-if="!isLoading && table.tableData == 0">
            <tr>
              <td colspan="12" class="text-center">
                <img src="@/assets/images/empty.svg" class="img-fluid" alt="" />
                <p>
                  <span class="text-secondary">No Data Found</span>
                </p>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="item in 20" :key="item">
              <td class="placeholder-glow" v-for="no in 11" :key="no">
                <span class="placeholder w-100 placeholder-lg"></span>
              </td>
            </tr>
          </tbody>
        </v-table>
      </div>
    </b-card>

    <!-- HOTEL FORM -->
    <Drawer
      @close="hotelForm"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1100"
    >
      <div v-if="isShowCustomerForm">
        <CustomerDetails
          :hotelDetails="this.selectedCustomer"
          :isEdit="this.isEdit"
          @cancelSubmit="hotelForm"
          @submitted="handleHotelSubmit"
        />
      </div>
    </Drawer>
  </div>
</template>

<style scoped>
.w-120 {
  width: 120px;
}
.w-160 {
  width: 180px;
}
.w-240 {
  width: 240px;
}
</style>
